import React, { useCallback } from "react";
import {
  Typography,
  MenuItem,
  Select,
  FormControl,
  TextField,
  TextareaAutosize,
} from "@mui/material";

// Tab 4: Delivery Terms
const DeliveryTermsTab = ({
  // setLoading,
  destination,
  setDestination,
  deliveryPort,
  setDeliveryPort,
  incoterm,
  setIncoterm,
  incotermsMaster,
  shippingMethodMaster,
  // setIncotermsMaster,
  deliveryPeriodFrom,
  setDeliveryPeriodFrom,
  deliveryPeriodTill,
  setDeliveryPeriodTill,
  shippingMethodPreference,
  setShippingMethodPreference,
  partialDeliveryAllowed,
  setPartialDeliveryAllowed,
  additionalLogisticsNotes,
  setAdditionalLogisticsNotes,
  unloadingResponsibility,
  setUnloadingResponsibility,
  transshipmentAllowed,
  setTransshipmentAllowed,
  countrymaster,
  formPortList,
  loadFormPorts,
  errors,
  isViewMode,
}) => {
  const handleDestinationChange = useCallback(
    (e) => {
      if (!isViewMode) {
        setDestination(e.target.value);
        loadFormPorts(e.target.value);
        setDeliveryPort("");
      }
    },
    [setDestination, loadFormPorts, setDeliveryPort, isViewMode]
  );

  return (
    <div className="row g-3">
      <div className="col-md-6">
        <FormControl sx={{ minWidth: "100%" }} error={!!errors.destination}>
          <Typography variant="body2">Destination Country *</Typography>
          {isViewMode ? (
            <TextField
              value={destination}
              disabled={true}
              sx={{ backgroundColor: "white", width: "100%" }}
              placeholder="No destination selected"
            />
          ) : (
            <Select
              value={destination}
              onChange={handleDestinationChange}
              displayEmpty
              sx={{ backgroundColor: "white" }}
              disabled={isViewMode}
            >
              <MenuItem value="" disabled>
                Select Destination
              </MenuItem>
              {countrymaster.map((p) => (
                <MenuItem key={p.ID} value={p.Value}>
                  {p.Value}
                </MenuItem>
              ))}
            </Select>
          )}
          {errors.destination && (
            <Typography variant="caption" color="error">
              {errors.destination}
            </Typography>
          )}
        </FormControl>
      </div>
      <div className="col-md-6">
        <FormControl sx={{ minWidth: "100%" }} error={!!errors.deliveryPort}>
          <Typography variant="body2">Delivery Port *</Typography>
          {isViewMode ? (
            <TextField
              value={deliveryPort}
              disabled={true}
              sx={{ backgroundColor: "white", width: "100%" }}
              placeholder="No destination selected"
            />
          ) : (
            <Select
              value={deliveryPort}
              onChange={(e) => !isViewMode && setDeliveryPort(e.target.value)}
              displayEmpty
              sx={{ backgroundColor: "white" }}
              disabled={isViewMode}
            >
              <MenuItem value="" disabled>
                Select Delivery Port
              </MenuItem>
              {formPortList.map((option, index) => (
                <MenuItem key={index} value={option.Value}>
                  {option.Value}
                </MenuItem>
              ))}
            </Select>
          )}
          {errors.deliveryPort && (
            <Typography variant="caption" color="error">
              {errors.deliveryPort}
            </Typography>
          )}
        </FormControl>
      </div>
      <div className="col-md-4">
        <FormControl sx={{ minWidth: "100%" }}>
          <Typography variant="body2">Incoterm</Typography>
          {isViewMode ? (
            <TextField
              value={incoterm}
              disabled={true}
              sx={{ backgroundColor: "white", width: "100%" }}
              placeholder="No incoterm selected"
            />
          ) : (
            <Select
              value={incoterm}
              onChange={(e) => !isViewMode && setIncoterm(e.target.value)}
              displayEmpty
              sx={{ backgroundColor: "white" }}
              disabled={isViewMode}
            >
              <MenuItem value="">Select Incoterm</MenuItem>
              {incotermsMaster.map((p) => (
                <MenuItem key={p.ID} value={p.Value}>
                  {p.Value}
                </MenuItem>
              ))}
            </Select>
          )}
        </FormControl>
      </div>
      <div className="col-md-4">
        <Typography variant="body2">Delivery Period From *</Typography>
        <TextField
          type="date"
          value={deliveryPeriodFrom}
          onChange={(e) => !isViewMode && setDeliveryPeriodFrom(e.target.value)}
          sx={{ backgroundColor: "white", width: "100%" }}
          disabled={isViewMode}
          error={!!errors.title}
          helperText={errors.title}
        />
      </div>
      <div className="col-md-4">
        <Typography variant="body2">Delivery Period Till *</Typography>
        <TextField
          type="date"
          value={deliveryPeriodTill}
          onChange={(e) => !isViewMode && setDeliveryPeriodTill(e.target.value)}
          sx={{ backgroundColor: "white", width: "100%" }}
          disabled={isViewMode}
          error={!!errors.title}
          helperText={errors.title}
        />
      </div>
      <div className="col-md-6">
        <Typography variant="body2">Shipping Method Preference</Typography>
        <FormControl sx={{ minWidth: "100%" }}>
          {isViewMode ? (
            <TextField
              value={shippingMethodPreference}
              disabled={true}
              sx={{ backgroundColor: "white", width: "100%" }}
              placeholder="No destination selected"
            />
          ) : (
            <Select
              value={shippingMethodPreference}
              onChange={(e) =>
                !isViewMode && setShippingMethodPreference(e.target.value)
              }
              displayEmpty
              sx={{ backgroundColor: "white" }}
              disabled={isViewMode}
            >
              <MenuItem value="">Select Shipping Method</MenuItem>
              {shippingMethodMaster.map((p) => (
                <MenuItem key={p.ID} value={p.Value}>
                  {p.Value}
                </MenuItem>
              ))}
            </Select>
          )}
        </FormControl>
      </div>
      <div className="col-md-6">
        <FormControl sx={{ minWidth: "100%" }}>
          <Typography variant="body2">Unloading Responsibility</Typography>
          {isViewMode ? (
            <TextField
              value={unloadingResponsibility}
              disabled={true}
              sx={{ backgroundColor: "white", width: "100%" }}
              placeholder="No destination selected"
            />
          ) : (
            <Select
              value={unloadingResponsibility}
              onChange={(e) =>
                !isViewMode && setUnloadingResponsibility(e.target.value)
              }
              displayEmpty
              sx={{ backgroundColor: "white" }}
              disabled={isViewMode}
            >
              <MenuItem value="">Select Unloading Responsibility</MenuItem>
              <MenuItem value="Buyer">Buyer</MenuItem>
              <MenuItem value="Supplier">Supplier</MenuItem>
            </Select>
          )}
        </FormControl>
      </div>
      <div className="col-md-6">
        <FormControl sx={{ minWidth: "100%" }}>
          <Typography variant="body2">Partial Delivery Allowed</Typography>
          {isViewMode ? (
            <TextField
              value={partialDeliveryAllowed}
              disabled={true}
              sx={{ backgroundColor: "white", width: "100%" }}
              placeholder="No destination selected"
            />
          ) : (
            <Select
              value={partialDeliveryAllowed}
              onChange={(e) =>
                !isViewMode && setPartialDeliveryAllowed(e.target.value)
              }
              sx={{ backgroundColor: "white" }}
              disabled={isViewMode}
            >
              <MenuItem value={0}>No</MenuItem>
              <MenuItem value={1}>Yes</MenuItem>
            </Select>
          )}
        </FormControl>
      </div>
      <div className="col-md-6">
        <FormControl sx={{ minWidth: "100%" }}>
          <Typography variant="body2">Transshipment Allowed</Typography>
          {isViewMode ? (
            <TextField
              value={transshipmentAllowed}
              disabled={true}
              sx={{ backgroundColor: "white", width: "100%" }}
              placeholder="No destination selected"
            />
          ) : (
            <Select
              value={transshipmentAllowed}
              onChange={(e) =>
                !isViewMode && setTransshipmentAllowed(e.target.value)
              }
              sx={{ backgroundColor: "white" }}
              disabled={isViewMode}
            >
              <MenuItem value={0}>No</MenuItem>
              <MenuItem value={1}>Yes</MenuItem>
            </Select>
          )}
        </FormControl>
      </div>
      <div className="col-md-12">
        <Typography variant="body2">Additional Logistics Notes</Typography>
        <TextareaAutosize
          value={additionalLogisticsNotes}
          onChange={(e) =>
            !isViewMode && setAdditionalLogisticsNotes(e.target.value)
          }
          style={{
            backgroundColor: "white",
            width: "100%",
            minHeight: "56px",
            padding: "8px",
            borderRadius: "4px",
            border: "1px solid #ccc",
            fontFamily: "inherit",
            fontSize: "14px",
            resize: "vertical",
          }}
          minRows={2}
          placeholder="Enter additional logistics requirements or notes"
          disabled={isViewMode}
        />
      </div>
    </div>
  );
};
export default DeliveryTermsTab;
